export const setActiveOrder = (order) => dispatch => {
  return dispatch({ type: "SET_ACTIVE_ORDER", payload: order })
};